// Querys and Mutations
import {
  CREATE,
  UPDATE,
  GET_WITH_PAGINATION,
  DELETE,
  GET_ALL
} from '@/graphql/dailyControl/DiscountControlGraphql'

// models
import { ResponseDefault, Paginator, ResponseCustom } from '@/models'
import {
  DiscountControl,
  DiscountControlForm,
  DiscountControlWithPagination,
  FiltersDiscountControl
} from '@/models/dailyControl'

// apollo
import { apolloClient } from '@/apollo'
import { getFirstErrorApollo } from '@/utils/apollo'

const filtersDefault: FiltersDiscountControl = {
  dateEnd: null,
  dateStart: null,
  discountType: null,
  employee: null
}

class DiscountControlService {
  /**
   * Queries
   */
  async getWithPagination (perPage = 10, page = 1, filters: FiltersDiscountControl): Promise<DiscountControlWithPagination> {
    const result = await apolloClient.query({
      query: GET_WITH_PAGINATION,
      variables: {
        page: page,
        perPage: perPage,
        filters: {
          ...filters,
          employee: Number(filters.employee) > 0 ? Number(filters.employee) : null,
          discountType: Number(filters.discountType) > 0 ? Number(filters.discountType) : null
        }
      }
    })
    const pagination: Paginator = result.data.discountControlWithPagination.paginatorInfo
    const data: DiscountControl[] = result.data.discountControlWithPagination.data
    const response: DiscountControlWithPagination = {
      objects: data,
      pagination: pagination
    }
    return response
  }

  async getAll (filters: FiltersDiscountControl = filtersDefault): Promise<DiscountControl[]> {
    const result = await apolloClient.query({
        query: GET_ALL,
        variables: {
          filters: {
            ...filters,
            employee: Number(filters.employee) > 0 ? Number(filters.employee) : null,
            discountType: Number(filters.discountType) > 0 ? Number(filters.discountType) : null
          }
        }
    })
    return result.data.discountControls
  }

  /**
   * Mutations
   */
  create (form: DiscountControlForm): Promise<ResponseDefault> {
    return apolloClient.mutate({
      mutation: CREATE,
      variables: {
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  update (id: number, form: DiscountControlForm): Promise<ResponseCustom> {
    return apolloClient.mutate({
      mutation: UPDATE,
      variables: {
        id: id,
        input: form
      }
    }).then(() => {
      return {
        success: true,
        msg: 'success'
      }
    }).catch(e => {
      throw getFirstErrorApollo(e)
    })
  }

  async delete (id: number): Promise<ResponseDefault> {
    await apolloClient.mutate({
      mutation: DELETE,
      variables: {
        id: id
      }
    })
    return {
      success: true,
      errors: []
    }
  }
}

export default new DiscountControlService()
